import React, { useState, useEffect } from 'react';
import './TypeWriter.css';

const TypeWriter = ({ text, speed = 100, className = '', cursorColor = 'currentColor' }) => {
  const [displayText, setDisplayText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showCursor, setShowCursor] = useState(true);
  const [isTypingComplete, setIsTypingComplete] = useState(false);

  useEffect(() => {
    if (currentIndex < text.length) {
      const timeout = setTimeout(() => {
        setDisplayText(prev => prev + text[currentIndex]);
        setCurrentIndex(prev => prev + 1);
      }, speed);

      return () => clearTimeout(timeout);
    } else if (currentIndex === text.length && !isTypingComplete) {
      // Typing is complete, hide cursor after a short delay
      const timeout = setTimeout(() => {
        setIsTypingComplete(true);
        setShowCursor(false);
      }, 200);
      
      return () => clearTimeout(timeout);
    }
  }, [currentIndex, text, speed, isTypingComplete]);

  // Cursor blinking effect - only while typing
  useEffect(() => {
    if (!isTypingComplete) {
      const interval = setInterval(() => {
        setShowCursor(prev => !prev);
      }, 530);

      return () => clearInterval(interval);
    }
  }, [isTypingComplete]);

  return (
    <span className={`typewriter-container ${className}`}>
      <span className="typewriter-text">{displayText}</span>
      {!isTypingComplete && (
        <span 
          className={`typewriter-cursor ${showCursor ? 'visible' : 'hidden'}`}
          style={{ color: cursorColor }}
        >
          |
        </span>
      )}
    </span>
  );
};

export default TypeWriter;